// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"IR-z","inlineTitle":"JR-z","sponsoredAdsWrapper":"KR-z","marketplaceRecosWrapper":"LR-z"};